// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Permissoes_PegapermissoesResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for /permissoes/pegaPermissoes
 * Returns the user's permissions object with enriched User data
 */
import type { Permissoes_PegapermissoesUserRow } from './Permissoes_PegapermissoesUserRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Permissoes_PegapermissoesResponseDados {
Franquias: object
User: Permissoes_PegapermissoesUserRow
Capacidades: string[]
}

export type Permissoes_PegapermissoesResponse = ApiResponse<Permissoes_PegapermissoesResponseDados>;

registerResponseContract('Permissoes_PegapermissoesResponse', {
  Franquias:   { type: 'object',  required: true },
  User: {
    type: 'object',
    required: true,
    fields: {
      sub:         { type: 'string',  required: true },
      email:       { type: 'string',  required: true },
      name:        { type: 'string',  required: true },
      given_name:  { type: 'string',  required: true },
      family_name: { type: 'string',  required: true },
      groups:      { type: 'array',   required: false },
      language:    { type: 'string',  required: true },
      picture:     { type: 'string',  required: true },
      auth_time:   { type: 'number',  required: true },
      exp:         { type: 'number',  required: true },
      iat:         { type: 'number',  required: true },
      token_use:   { type: 'string',  required: true },
      client_id:   { type: 'string',  required: true },
    },
  },
  Capacidades: { type: 'array',   required: true },
})
